// Configuration for AWS Amplify and Cognito
// Auto-generated after CDK deployment
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-2_6uEFlTbIY',
      userPoolClientId: '491nsmq86e5kegts4vcdcbs5v',
      loginWith: {
        email: false,
        username: true,
        phone: false,
      },
    },
  },
};

// API Gateway URL (production)
export const API_BASE_URL = 'https://api-connect.fl3xkit.com';

// WebSocket URL (production - custom domain)
export const WS_URL = 'wss://ws-connect.fl3xkit.com';

// API Endpoints
export const API_ENDPOINTS = {
  // Inbox endpoint
  INBOX_V2: '/inbox/v2',        // Inbox with phone number filtering
  // Voicemail endpoint
  VOICEMAILS: '/app/voicemails', // Voicemails with audio URLs
}; 